var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[_c('a-tabs',{staticClass:"template__tabs",attrs:{"type":"card","tabBarStyle":{
      display: 'flex',
      marginBottom: '0px',
    },"tabBarGutter":8},on:{"change":_vm.handleChangeTab},model:{value:(_vm.tabSelected),callback:function ($$v) {_vm.tabSelected=$$v},expression:"tabSelected"}},_vm._l((_vm.tabs),function(tab){return _c('a-tab-pane',{key:tab.key,staticClass:"template__tab",attrs:{"tab":tab.title}},[_c('div',{staticClass:"template__tab-content"},[_c('router-view')],1)])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }